import React, { Component } from 'react';

import { AuctionFinalsList } from 'components/AuctionFinals/components';

class AwardAllSummary extends Component {
  render() {
    const { store } = this.props;
    const { sale } = store.auctionFinalsStore;

    return (
      <AuctionFinalsList
        sale={sale}
        store={store.auctionFinalsStore}
        locale={sale.saleEdit.locale}
        currency={sale.saleEdit.currencyCode}
        showResults={true}
        showTotals={true}
        style={{ width: '100%' }}
      />
    );
  }
}

export default AwardAllSummary;



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/AwardAll/Summary.jsx